import styled, {css} from "styled-components";

const TextWrap = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 20px;
	> p {
		display: inline-block;
		margin-left: auto;
		&::before {
			top: 4px;
			width: 0;
			height: 0;
			color: var(--red-color);
			vertical-align: middle;
			content: "*";
		}
	}
`;
const SubTitle = styled.h4`
	line-height: 1;
	margin-bottom: 20px;
	font-size: var(--medium-size);
	color: var(--emp-color);
`;
const ProductName = styled.strong`
	font-size: var(--medium-size);
	font-weight: normal;
	color: var(--emp-color);
`;
const TblLine = styled.div`
	display: flex;
	flex-direction: column;
`;
const InputRow = styled.div<{wrong?: boolean; padding?: boolean}>`
	+ div {
		padding-top: 10px;
		padding-bottom: 0;
		border-top: 1px dashed var(--line-color);
	}
	> span {
		display: inline-block;
		padding: 0 8px;
	}

	${props =>
		props.padding
			? `
		padding-bottom: 10px;
	`
			: ``}
	${props =>
		props.wrong
			? css`
					> p {
						display: block;
					}
					input:not([type="checkbox"]),
					> div > div,
					textarea {
						border-color: red;
					}

					input:focus {
						border-color: currentcolor;
					}
			  `
			: css`
					> p {
						display: none;
					}
			  `}
`;

const CheckWrap = styled.div`
	display: flex;
	gap: 6px;
	margin-top: 10px;
	margin-left: 71px;
	label {
		line-height: 21px;
	}
`;

const InputLabel = styled.label`
	display: inline-block;
	width: 50px;
	margin-right: 20px;
`;

const SelectWrap = styled.div`
	position: relative;
	display: inline-block;
	width: 150px;
	height: 40px;
	margin-left: 10px;
`;
const BulletList = styled.ul`
	margin-top: 10px;
`;
const AgreeBox = styled.div`
	margin-top: 20px;
	border: 1px solid var(--line-color);
`;
const AgreeText = styled.div`
	padding: 30px 40px;
`;
const AgreeCheck = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 15px 0 15px 40px;
	border-top: 1px solid #ddd;
	background: var(--disabled-color);
	> input {
		margin-right: 10px;
	}
	> label {
		color: var(--emp-color);
	}
`;
const AgreeCheckWrap = styled.div`
	display: flex;
	gap: 6px;
`;

const AgreeList = styled.ul`
	display: flex;
	flex-direction: column;
`;
const AgreeListItem = styled.li`
	position: relative;
	padding-left: 10px;
	line-height: 24px;
	font-size: var(--default-size);
	&::before {
		position: absolute;
		left: 0;
		padding-right: 5px;
		content: "-";
	}
`;
const BtnArea = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 40px;
	button {
		width: 140px;
	}
`;
const RequiredCheck = styled.span`
	position: absolute;
	top: 50%;
	left: 10px;
	height: 16px;
	transform: translateY(-50%);

	&::before {
		display: inline;
		color: var(--red-color);
		content: "*";
	}
`;

const InfoText = styled.span`
	line-height: 1;
	font-size: 14px;
	text-align: right;
	> span {
		margin-right: 4px;
	}
`;

const RequiredIcon = styled.span`
	display: inline-block;
	vertical-align: middle;

	&::before {
		display: inline;
		color: var(--red-color);
		content: "*";
	}
`;

export {
	AgreeBox,
	AgreeCheck,
	AgreeCheckWrap,
	AgreeList,
	AgreeListItem,
	AgreeText,
	BtnArea,
	BulletList,
	CheckWrap,
	InputLabel,
	InputRow,
	ProductName,
	RequiredCheck,
	SelectWrap,
	SubTitle,
	TblLine,
	TextWrap,
	InfoText,
	RequiredIcon,
};
